import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'
import { MetaWrapper } from '@components/Meta'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useTrackOrderLazyQuery } from '@graphql/queries/__generated__/order.generated'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { useQueryParams } from 'use-query-params'
import { getOrderDetailsUrl } from '../../../urls'
import TrackOrderPage, { TrackOrderFormData } from './TrackOrderPage'
import { useTranslation } from 'react-i18next'

const TrackOrderView: React.FC = ({}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const meQuery = useMeQuery()
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)
  const [formErrors, setFormErrors] = useState(null)
  const [trackOrder] = useTrackOrderLazyQuery({
    onCompleted: data => {
      if (data?.order) {
        setFormErrors(null)
        history.push(getOrderDetailsUrl(data.order.token))
      } else {
        setFormErrors({
          pubId: t(
            'formErrors.enterValidOrderNumberAndEmail',
            'Please enter a valid order number and email combination.'
          ),
        })
      }
    },
  })
  const handleFindOrder = async (values: TrackOrderFormData) => {
    try {
      setFormErrors(null)
      await trackOrder({
        variables: {
          pubId: values.pubId,
          email: values.email,
        },
      })
    } catch (e) {
      console.error(e.message)
    }
  }
  const handleContactUs = () => {
    setParams({ global_dialog_form: 'contactUs' }, 'replaceIn')
  }

  return (
    <MetaWrapper titleDetails={t('metaTitle.trackOrder', 'Track order')}>
      <TrackOrderPage
        onSubmit={handleFindOrder}
        me={meQuery.data?.me}
        handleSignIn={() => setParams({ global_dialog_form: 'signIn' }, 'replaceIn')}
        handleRegister={() => setParams({ global_dialog_form: 'signUp' }, 'replaceIn')}
        handleContactUs={handleContactUs}
        formErrors={formErrors}
      />
    </MetaWrapper>
  )
}

export default TrackOrderView
